<template>
  <table
    v-bind="$props"
    ref="tableElement"
    style="margin-bottom: 20px !importantmargin-top: 20px !important"
  >
    <slot></slot>
  </table>
</template>
<script>
import $ from 'jquery'
// import '@sass/vuexy/extraComponents/datatableStyle.scss'
// require('bootstrap')
require('jquery-ui-bundle')
require('jquery-ui-bundle/jquery-ui.min.css')
require('yadcf')
require('yadcf/jquery.dataTables.yadcf.css')

// Datatables
require('datatables.net-bs4')
require('datatables.net-bs4/js/dataTables.bootstrap4.js')
require('datatables.net-bs4/css/dataTables.bootstrap4.css')
require('datatables.net-autofill-bs4')
require('datatables.net-buttons-bs4')
require('datatables.net-buttons/js/buttons.colVis.js') // Column visibility
require('datatables.net-buttons/js/buttons.html5.js') // HTML 5 file export
require('datatables.net-buttons/js/buttons.flash.js') // Flash file export
require('datatables.net-buttons/js/buttons.print.js') // Print view button
require('datatables.net-colreorder-bs4')
require('datatables.net-fixedcolumns-bs4')
require('datatables.net-fixedheader-bs4')
require('datatables.net-keytable-bs4')
require('datatables.net-responsive')
require('datatables.net-responsive-bs4')
require('datatables.net-rowgroup-bs4')
require('datatables.net-rowreorder-bs4')
require('datatables.net-scroller-bs4')
// require( 'datatables.net-searchpanes-bs4' )
require('datatables.net-select-bs4')

require('jszip/dist/jszip.js')
require('pdfmake/build/pdfmake.js')
require('pdfmake/build/vfs_fonts.js')

/**
 * Wrapper component for dataTable plugin
 * Only DOM child elements, componets are not supported (e.g. <Table>)
 */
export default {
  name: 'vx-datatable',
  props: {
    filtros: {
      type: Array,
      default: () => []
    },
    /** datatables options object */
    options: {
      type: Object,
      default: () => {}
    },
    /** callback that receives the datatable instance as param */
    dtInstance: Function
  },

  mounted () {
    const dtInstance = $(this.$refs.tableElement).dataTable(this.options)
    if (this.filtros.length > 0) {
      dtInstance.yadcf(this.filtros)
    }

    if (this.dtInstance) {
      this.dtInstance(dtInstance)
    }
  },

  destroyed () {
    $(this.$refs.tableElement).dataTable({ destroy: true })
  }
}
</script>

